var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pr-wrapper',{attrs:{"id":"worker","fs":"","zi":"0"},nativeOn:{"nv-delete":function($event){return (($event) => _vm.$channelSelectWithNumber($event, false)).apply(null, arguments)},"nv-numpad":function($event){return (($event) => _vm.$channelSelectWithNumber($event, false)).apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }